import { injectable } from "inversify";
import "reflect-metadata";

import type { App } from "../../domain/entities/app";
import type { Namespace } from "../../domain/entities/namespace";
import type { Tool } from "../../domain/entities/tool";
import type { NamespaceIdentification } from "./namespace-identification";

@injectable()
export abstract class NavigationRepository {
  abstract getAccessibleApps(): Promise<App[]>;
  abstract getAccessibleTools(): Promise<Tool[]>;
  abstract listUserNamespaces(): Promise<Namespace[]>;
  abstract getNamespaceIdentification(namespaceId: string): Promise<NamespaceIdentification>;
}
